import { generateShortDateString } from "@/domains/date/date";
import { LensKind, SortByKind } from "@/modules/lenses/types";
import { INoteObservable, NotesSortByKind } from "@/store/note";

export const notesLensSortFunctionMap: {
  [key in NotesSortByKind]: (a: INoteObservable, b: INoteObservable) => number;
} = {
  [SortByKind.LastModified]: (a: INoteObservable, b: INoteObservable) =>
    new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime(),
  [SortByKind.LastCreated]: (a: INoteObservable, b: INoteObservable) =>
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  [SortByKind.LastViewed]: (a: INoteObservable, b: INoteObservable) =>
    new Date(b.spaceAccountNote?.lastViewedAt || b.createdAt).getTime() -
    new Date(a.spaceAccountNote?.lastViewedAt || a.createdAt).getTime(),
  [SortByKind.Alphabetical]: (a: INoteObservable, b: INoteObservable) =>
    a.title.localeCompare(b.title),
  // TODO: Add sharedWithMeAt
  [SortByKind.LastShared]: (a: INoteObservable, b: INoteObservable) =>
    new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime(),
  [SortByKind.LastInteracted]: (a: INoteObservable, b: INoteObservable) =>
    new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime(),
};

export const notesLensDateLabelMap: {
  [key in NotesSortByKind]: (note: INoteObservable) => string;
} = {
  [SortByKind.LastModified]: note => generateShortDateString(note.modifiedAt),
  [SortByKind.LastCreated]: note => generateShortDateString(note.locallyCreatedAt),
  [SortByKind.LastViewed]: note =>
    generateShortDateString(note.spaceAccountNote?.lastViewedAt || note.locallyCreatedAt),
  [SortByKind.Alphabetical]: note => generateShortDateString(note.modifiedAt),
  // TODO: Add sharedWithMeAt
  [SortByKind.LastShared]: note => generateShortDateString(note.modifiedAt),
  [SortByKind.LastInteracted]: note => generateShortDateString(note.modifiedAt),
};

export const notesLensFilterFunctionMap: {
  [key in LensKind]: (note: INoteObservable) => boolean;
} = {
  [LensKind.All]: () => true,
  [LensKind.AddedByMe]: note => note.isOwnedByMe,
  [LensKind.SharedWithMe]: note => !note.isOwnedByMe,
};
